import { z } from 'zod';

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
    cli: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    accountHome: z.string().min(1),
    accountSettings: z.string().min(1),
    accountBilling: z.string().min(1),
    accountMembers: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    accountEvents: z.string().min(1),
    accountCommercial: z.string().min(1),
    accountStmRenewal: z.string().min(1),
    accountMarketingFanFunnel: z.string().min(1),
    accountVault: z.string().min(1),
    accountScouting: z.string().min(1),
    accountScoutingWatchlist: z.string().min(1),
    accountScoutingWatchlistDetail: z.string().min(1),
    accountScoutingPlayer: z.string().min(1),
    accountPlanning: z.string().min(1),
    accountPlanningDocuments: z.string().min(1),
    accountPlanningTemplates: z.string().min(1),
    accountBlueprintTemplates: z.string().min(1),
    accountSsoSettings: z.string().min(1),
    accountContextImports: z.string().min(1),
    accountGroupAssignment: z.string().min(1),
    accountCommercialSettings: z.string().min(1),
    accountSettingsEvents: z.string().min(1),
    accountSettingsEventMatchMappings: z.string().min(1),
    accountIntegrations: z.string().min(1),
    accountIntegrationsNew: z.string().min(1),
    accountMeetingAssistant: z.string().min(1),
    accountPlaybooks: z.string().min(1),
    accountSkills: z.string().min(1),
    accountSkillsNew: z.string().min(1),
    accountSkillDetail: z.string().min(1),
    accountSkillActivity: z.string().min(1),
    accountWorkspaces: z.string().min(1),
    accountWorkspaceDetail: z.string().min(1),
    accountTasks: z.string().min(1),
    accountProfileSettings: z.string().min(1),
    createTeam: z.string().min(1),
    joinTeam: z.string().min(1),
    events: z.object({
      home: z.string().min(1),
      detail: z.string().min(1),
      narratives: z.string().min(1),
      blueprint: z.string().min(1),
      blueprintReconcile: z.string().min(1),
    }),
  }),
  admin: z.object({}),
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    verifyMfa: '/auth/verify',
    callback: '/auth/callback',
    passwordReset: '/auth/password-reset',
    passwordUpdate: '/update-password',
    cli: '/auth/cli',
  },
  app: {
    home: '/home',
    personalAccountSettings: '/home/settings',
    personalAccountBilling: '/home/billing',
    personalAccountBillingReturn: '/home/billing/return',
    accountHome: '/home/[account]',
    accountSettings: `/home/[account]/settings`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/settings/members`,
    accountBillingReturn: `/home/[account]/billing/return`,
    accountEvents: `/home/[account]/events`,
    accountCommercial: `/home/[account]/commercial`,
    accountStmRenewal: `/home/[account]/stm-renewal`,
    accountMarketingFanFunnel: '/home/[account]/marketing-fan-funnel',
    accountVault: `/home/[account]/vault`,
    accountScouting: `/home/[account]/scouting`,
    accountScoutingWatchlist: `/home/[account]/scouting/watchlist`,
    accountScoutingWatchlistDetail: `/home/[account]/scouting/watchlist/[watchlistId]`,
    accountScoutingPlayer: `/home/[account]/scouting/players/[playerId]`,
    accountPlanning: `/home/[account]/planning`,
    accountPlanningDocuments: `/home/[account]/planning`,
    accountPlanningTemplates: `/home/[account]/planning/templates`,
    accountBlueprintTemplates: `/home/[account]/settings/blueprint-templates`,
    accountSsoSettings: `/home/[account]/settings/permissions`,
    accountContextImports: `/home/[account]/settings/context-imports`,
    accountGroupAssignment: `/home/[account]/settings/group-assignment`,
    accountCommercialSettings: `/home/[account]/settings/commercial`,
    accountSettingsEvents: `/home/[account]/settings/events`,
    accountSettingsEventMatchMappings: `/home/[account]/settings/events/match-mappings`,
    accountIntegrations: `/home/[account]/settings/integrations`,
    accountIntegrationsNew: `/home/[account]/settings/integrations/new`,
    accountMeetingAssistant: `/home/[account]/meeting-assistant`,
    accountPlaybooks: `/home/[account]/agents`,
    accountSkills: `/home/[account]/agents/skills`,
    accountSkillsNew: `/home/[account]/agents/skills/new`,
    accountSkillDetail: `/home/[account]/agents/skills/[id]`,
    accountSkillActivity: `/home/[account]/agents/skills/[id]/activity`,
    accountWorkspaces: `/home/[account]/workspaces`,
    accountWorkspaceDetail: `/home/[account]/workspaces/[id]`,
    accountTasks: `/home/[account]/tasks`,
    accountProfileSettings: `/home/[account]/settings/profile`,
    createTeam: '/home/create-team',
    joinTeam: '/join',
    events: {
      home: `/home/[account]/events`,
      detail: `/home/[account]/events/[id]`,
      narratives: `/home/[account]/events/[id]`,
      blueprint: `/home/[account]/events/[id]/blueprint`,
      blueprintReconcile: `/home/[account]/events/[id]/blueprint/reconcile`,
    },
  },
  admin: {},
} satisfies z.infer<typeof PathsSchema>);

export function getPathsConfig() {
  return pathsConfig;
}

export default pathsConfig;
